import { ca } from '@cian/analytics';
import { EPlatform, TPlatform } from '../../types/platform';
import { MOBILE_APP_UNSUPPORTED_BANNER_TITLE } from './constants';

const platformLabel = {
  [EPlatform.Ios]: 'app_iOS',
  [EPlatform.Android]: 'app_android',
  [EPlatform.Other]: 'desktop',
};

export function trackShowBanner(platform: TPlatform) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Install_app_banner',
    label: platformLabel[platform],
    page: {
      extra: { bannerName: MOBILE_APP_UNSUPPORTED_BANNER_TITLE },
    },
  });
}

export function trackClickOnBanner(platform: TPlatform) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'Install_app_banner',
    label: platformLabel[platform],
    page: {
      extra: { bannerName: MOBILE_APP_UNSUPPORTED_BANNER_TITLE },
    },
  });
}
